export default "__VITE_ASSET__DdKrawY4__"